import React from 'react';
import {
  Spinner, Cards, Button, CardsFiltering,
  CardsPagination, CardsPreferences, CardsPageSizeSelector
} from '@amzn/awsui-components-react/polaris';

import CardsConfig from '../res/CardsConfig';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return { domains: state.domains, isLoading: state.appState.isLoading }
}

class Dashboard extends React.Component {
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // componentWillMount(){
  //   var navigateToParameter = this.getParameterByName("navigateTo");
  //   var navigateToArray = navigateToParameter ? navigateToParameter.split(",") : [];
  //   var navigateToString = "";

  //   navigateToArray.forEach(element => {
  //     if(element !== "")
  //       navigateToString += element + "/";
  //   });
  //   console.log(navigateToString);
  //   this.props.history.push(navigateToString);
  // }

  render() {
    if (this.props.isLoading) {
      return (
        <Spinner size='large'></Spinner>
      );
    }
    var items = this.props.domains;
    if (items) {
      //Sorting Profiles in ascending order for home page
      items.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));

      items = items.map(domain => {
        var obj = {};
        obj.id = domain.id;
        obj.name = domain.name;
        obj.description = domain.description;
        return obj;
      });
    } else {
      items = [];
    }

    return (
      <Cards
        cardsPerRow={CardsConfig.cardsPerRow}
        cardDefinition={CardsConfig.cardDefinition}
        items={items}
        header={
          <h2>
            Profiles
          </h2>
        }
        empty={<div className="awsui-util-t-c">
          <div className="awsui-util-pt-xs awsui-util-mb-xs">
            <b>
              Empty resources
            </b>
          </div>
          <p className="awsui-util-mb-s">
            No resources to display
          </p>
          <div className="awsui-util-mb-l">
            <Button text="Request new domain"></Button>
          </div>
        </div>}
        noMatch={<div className="awsui-util-t-c">
          <div className="awsui-util-pt-xs awsui-util-mb-xs">
            <b>
              No matches
            </b>
          </div>
          <p className="awsui-util-mb-s">
            No results match your query
          </p>
          <div className="awsui-util-mb-l">
            <Button text="Clear filter"></Button>
          </div>
        </div>}
      >
        <CardsFiltering></CardsFiltering>
        <CardsPagination></CardsPagination>
        {/* <CardsSelection selectionType="single" trackBy="name" onSelectionChange={this.dispatchNavigation}></CardsSelection> */}
        <CardsPreferences
          title="Preferences"
          confirmLabel="Confirm"
          cancelLabel="Cancel"
        >
          <CardsPageSizeSelector title="Items per page" value={CardsConfig.cardsPageSizeSelectorDefaultValue} options={CardsConfig.cardsPageSizeSelectorOptions}></CardsPageSizeSelector>
        </CardsPreferences>
      </Cards>
    );
  }
}

export default connect(mapStateToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/app/components/Dashboard.jsx